export default __webpack_public_path__ + "static/media/11.21.0323c34f.jpg";